__turbopack_context__.v({
  "actinItemIcon": "ComparableBoatCard-module-scss-module__zSoXmq__actinItemIcon",
  "cardBodyWrapper": "ComparableBoatCard-module-scss-module__zSoXmq__cardBodyWrapper",
  "comparableBoatCard": "ComparableBoatCard-module-scss-module__zSoXmq__comparableBoatCard",
  "comparableBoatCardWrapper": "ComparableBoatCard-module-scss-module__zSoXmq__comparableBoatCardWrapper",
  "footerWrapper": "ComparableBoatCard-module-scss-module__zSoXmq__footerWrapper",
  "headerWrapper": "ComparableBoatCard-module-scss-module__zSoXmq__headerWrapper",
  "seeMoreBtn": "ComparableBoatCard-module-scss-module__zSoXmq__seeMoreBtn",
});
